<template>
    <header class="mobileHeader">
        <Logo/>
        <div class="rightColumn">
            <NotificationSystem
                v-if="auth.id"/>
            <Button v-else-if="$route.name !== 'auth'"
                url="/auth"
                appearance="secondary"
                prefixIcon="person_add_alt"
                size="small"
                iconSize="s">
                {{ siteContent.signUp }}
            </Button>
            <GlobalMenu class="apps"/>
        </div>
    </header>
</template>

<script>
    import NotificationSystem from '@/components/notifications/NotificationSystem'
    import GlobalMenu         from '@/components/layout/header/GlobalMenu'

    export default {
        name: 'MobileHeader',
        components: {
            NotificationSystem,
            GlobalMenu
        }
    }
</script>

<style scoped lang="scss">
    @import '../../scss/variables';

    .mobileHeader {
        display: none;
        position: relative;
        position: sticky;
        top: 0;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        height: 3.5rem;
        padding: 0.5rem 1rem;
        z-index: 8;
        background: var(--color-white-40);
        backdrop-filter: blur(2rem);
        border-radius: 0 0 1.5rem 1.5rem;
    }

    .rightColumn {
        display: flex;
    }

    .apps {
        margin-left: 0.5rem;
    }

    @media all and (max-width: 1200px) {
        .mobileHeader {
            display: flex;
        }
    }
</style>